<template>
  <div>
    <section class="uc-videoHeader">
      <div class="box">
        <div class="item">
          <div class="name">{{ model.name }}</div>
        </div>
        <div class="item">
          课时：{{ model.period }}分钟&nbsp;|&nbsp;累计学习：{{
            (model.learn_duration + learnTime) / 60 >= model.period * 3
              ? model.period * 3
              : ((model.learn_duration + learnTime) / 60).toFixed(1)
          }}分钟&nbsp;|&nbsp;本次学习：{{
            learnTime >= 60 ? parseInt(learnTime / 60) : 0
          }}分钟{{ learnTime % 60 }}秒
        </div>
        <div class="item">
          <button class="btn-back" hover-class="none" @click="btnExitCourse">
            <img src="../../assets/images/icon-out.png" class="uc-icon24" />
            退出课程
          </button>
        </div>
      </div>
      <div class="marquee">
        注意：结束学习时请点击"退出课程"按钮，如直接关闭页面，可能存在学习进度不准问题。
      </div>
    </section>

    <section class="uc-videoBox" ref="waterContent">
      <iframe
        v-if="model.type == 12 || model.type == 2004"
        :src="model.scorm_viewer_url"
        style="width: 100%; height: 100%"
        allowfullscreen="true"
        frameborder="0"
      ></iframe>
      <!-- HasSideList 控制是否显示左侧目录 -->
      <div
        v-else
        class="box"
        :class="showSideList && showCourseChapter ? 'HasSideList' : ''"
      >
        <div v-if="model.type === 3">
          <div
            class="btnsSideList"
            @click="btnShowSideList"
            v-show="showCourseChapter"
          >
            <div class="con con-left">
              <i class="uc-font uc-arrow-right"></i>
            </div>
            <div class="con con-right">
              <i class="uc-font uc-arrow-left"></i>
            </div>
          </div>
          <!-- hasThree 控制是否显示第三屏 -->
          <div class="box-left hasThree" v-show="showCourseChapter">
            <div class="small-box">
              <div
                v-if="this.$utils.matchType(iframeMediaUrl) === 'image'"
                class="img-box"
              >
                <el-image :src="model.cover">
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/default-kc.png" />
                  </div>
                </el-image>
              </div>
              <div v-else style="height: 200px">
                <VideoPlayer ref="mVideo"></VideoPlayer>
              </div>
            </div>

            <div class="list">
              <div class="title">目录</div>
              <ul>
                <li
                  v-for="(item, index) in model.course_chapter_list"
                  :key="index"
                  :class="item.class.join(' ')"
                >
                  <a
                    href="javascript:;;"
                    :title="item.name"
                    @click="clickChapter(item)"
                    >{{ item.name }}</a
                  >
                </li>
                <!-- <li class="ok">第一章节</li>
              <li class="ok">第一章节</li>
              <li class="on">第一章节</li>
              <li>第一章节</li>
              <li>第一章节</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="box-right">
          <div v-if="model.type == 1">
            <div
              v-if="this.$utils.matchType(iframeContentUrl) === 'video'"
              style="height: calc(100vh - 120px)"
            >
              <VideoPlayer ref="cVideo"></VideoPlayer>
            </div>
            <div v-else-if="this.$utils.matchType(iframeContentUrl) === 'pdf'">
              <iframe
                :src="iframePdfUrl"
                style="width: 100%; height: calc(100vh - 120px)"
                allowfullscreen="true"
                frameborder="0"
              />
            </div>
            <div v-else>
              <iframe
                :src="iframeContentUrl"
                style="width: 100%; height: calc(100vh - 120px)"
                allowfullscreen="true"
                frameborder="0"
              ></iframe>
            </div>
          </div>
          <div v-else>
            <div
              v-if="this.$utils.matchType(iframeContentUrl) === 'video'"
              style="height: calc(100vh - 120px)"
            >
              <VideoPlayer ref="cVideo"></VideoPlayer>
            </div>
            <div v-else-if="this.$utils.matchType(iframeContentUrl) === 'pdf'">
              <iframe
                :src="iframePdfUrl"
                style="width: 100%; height: calc(100vh - 120px)"
                allowfullscreen="true"
                frameborder="0"
              />
            </div>
            <div v-else>
              <iframe
                :src="iframeContentUrl"
                style="width: 100%; height: calc(100vh - 120px)"
                allowfullscreen="true"
                frameborder="0"
              ></iframe>
            </div>
          </div>
          <!-- <div class="bottom-operate">
            <div class="btns">
              <router-link to class="btns" hover-class="none">
                <el-tooltip content="分享" placement="top" effect="light">
                  <i class="el-icon-share"></i>
                </el-tooltip>
              </router-link>
            </div>
            <div class="btns on">
              <router-link to class="btns" hover-class="none">
                <el-tooltip content="收藏" placement="top" effect="light">
                  <i class="el-icon-collection"></i>
                </el-tooltip>
              </router-link>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <section class="uc-FixedSideMenu play">
      <div class="box" v-if="!showFixedNote" @click="btnshowFixedNote">
        <div class="btn-menu">
          <img src="../../assets/images/icon-menu.png" class="uc-icon24" />
          笔记
        </div>
      </div>
      <div class="box" v-if="!showFixedDiscuss" @click="btnshowFixedDiscuss">
        <div class="btn-discuss">
          <img src="../../assets/images/icon-discuss.png" class="uc-icon24" />
          评价
        </div>
      </div>
      <div class="box" v-if="!showFixedCDiscuss" @click="btnshowFixedCDiscuss">
        <div class="btn-discuss">
          <img src="../../assets/images/icon-discuss.png" class="uc-icon24" />
          讨论
        </div>
      </div>
      <div class="box note" v-if="showFixedNote">
        <div class="title">
          <img src="../../assets/images/icon-menu.png" class="uc-icon24" />
          <div class="c">笔记</div>
          <i class="uc-font uc-close" @click="btnshowFixedNote"></i>
        </div>
        <div class="form">
          <textarea
            class="uc-textarea"
            placeholder="添加您的笔记"
            cols="30"
            rows="10"
            v-model="noteContent"
          ></textarea>
          <div class="operate">
            <button
              class="uc-btn blue"
              hover-class="none"
              @click="btnSubmitCourseNote(0)"
            >
              保存
            </button>
          </div>
        </div>
        <div class="list-note">
          <h3>您的笔记</h3>
          <div
            v-for="(item, index) in noteList.items"
            :key="index"
            class="item"
          >
            <div class="con">
              <i class="number">{{ index + 1 }}.</i>
              {{ item.content }}
            </div>
            <div class="btm">
              <time>{{ item.create_time }}</time>
            </div>
          </div>
        </div>
      </div>
      <div class="box discuss" v-if="showFixedDiscuss">
        <div class="title">
          <img src="../../assets/images/icon-discuss.png" class="uc-icon24" />
          <div class="c">课程评价</div>
          <i class="uc-font uc-close" @click="btnshowFixedDiscuss"></i>
        </div>
        <div class="form" v-if="!isEvaluation">
          <div class="star">
            <el-rate
              v-model="myEvaluationScore"
              show-score
              text-color="#ff9900"
              score-template="{value}分"
            >
            </el-rate>
          </div>
          <textarea
            v-model="evaluationContent"
            class="uc-textarea"
            placeholder="请输入评价内容"
            cols="30"
            rows="10"
          ></textarea>
          <div class="operate">
            <button
              class="uc-btn blue"
              hover-class="none"
              @click="btnSubmitCourseEvaluation"
            >
              发表
            </button>
          </div>
        </div>
        <div class="list-discuss">
          <div
            v-for="(item, index) in evaluationList.items"
            :key="index"
            class="item"
          >
            <div class="user">
              <img :src="item.avatar" class="face" />
              <i class="uc-blue">{{ item.create_user_name }}</i>
            </div>
            <div class="con">
              {{ item.content }}
            </div>
            <div class="btm">
              <el-rate
                disabled
                show-score
                text-color="#ff9900"
                :value="item.score"
                score-template="{value}分"
              >
              </el-rate>
              <time>{{ item.create_time }}</time>
            </div>
          </div>
        </div>
      </div>
      <div class="box discuss" v-if="showFixedCDiscuss">
        <div class="title">
          <img src="../../assets/images/icon-discuss.png" class="uc-icon24" />
          <div class="c">课程讨论</div>
          <i class="uc-font uc-close" @click="btnshowFixedCDiscuss"></i>
        </div>
        <div class="form">
          <textarea
            v-model="cDiscussContent"
            class="uc-textarea"
            placeholder="请输入讨论内容"
            cols="30"
            rows="10"
          ></textarea>
          <div class="operate">
            <button
              class="uc-btn blue"
              hover-class="none"
              @click="btnSubmitCourseCDiscuss"
            >
              发表
            </button>
          </div>
        </div>
        <div class="list-discuss">
          <div
            v-for="(item, index) in cdiscussList.items"
            :key="index"
            class="item"
          >
            <div class="user">
              <img :src="item.avatar" class="face" />
              <i class="uc-blue">{{ item.create_user_name }}</i>
            </div>
            <div class="con">
              {{ item.content }}
            </div>
            <div class="btm">
              <time>{{ item.create_time }}</time>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer.vue';
import watermark from '@/utils/watermark.js';

export default {
  name: 'CoursePlay',
  components: {
    VideoPlayer,
  },
  data() {
    return {
      query: {
        id: this.$route.params.id,
      },
      queryNote: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      queryEvaluation: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      queryCDiscuss: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      model: { learn_duration: 0 },
      noteList: [],
      noteContent: '',
      evaluationList: [],
      cdiscussList: [],
      isEvaluation: false,
      evaluationContent: '',
      myEvaluationScore: 0,

      showSideList: true,
      showCourseChapter: false,
      showFixedNote: false,
      showFixedDiscuss: false,
      showFixedCDiscuss: false,

      coursePoster: '',
      iframeContentUrl: '',
      iframeMediaUrl: '',
      iframePdfUrl: '',

      learnTime: 0,
      isPause: false,
      isExist: false,
      currentTime: 0, //当前播放时间点
      maxCurrentTime: 0, //最大播放时间
      duration: 0, //本视频的时长
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    watermark.set(
      this.$store.getters.user.first_name +
        ' ' +
        this.$store.getters.user.username,
      this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      this.$refs.waterContent
    );
    // 百科跳转
    window.addEventListener(
      'message',
      (e) => {
        if (typeof e.data === 'string') {
          const data = JSON.parse(e.data);
          if (data.type === 'knowpoint') {
            window.open('/knowpoint/' + data.id);
          }
        }
      },
      false
    );
    // 关闭窗口时记录学习进度
    window.onbeforeunload = () => {
      if (!this.isExist) {
        this.handlerCourseTrace();
      }
    };
  },
  methods: {
    loadData() {
      this.getCoursePlayDetails();
      this.getMyCourseNotes();
      this.getCourseEvaluation();
      this.loadCDiscussData();
    },
    loadNoteData() {
      this.getMyCourseNotes();
    },
    loadEvaluationData() {
      this.getCourseEvaluation();
    },
    loadCDiscussData() {
      this.getCourseCDiscuss();
    },
    async getCoursePlayDetails() {
      const response = await this.$api.course.getCoursePlayDetails(this.query);
      if (response.data.code === 200) {
        const model = response.data.data;
        for (const chapter of model.course_chapter_list) {
          chapter.class = [];
        }
        this.model = model;
        // 是否评价
        this.isEvaluation = this.model.evaluation_count > 0;
        // 我的评分
        this.myEvaluationScore = this.model.my_evaluation_score;

        // 左侧菜单
        this.showCourseChapter = this.model.type === 3;
        // 设置视频地址：引用地址和三分屏内容地址一致
        this.coursePoster = this.model.cover;
        for (const chapter of this.model.course_chapter_list) {
          const classArr = [];
          if (chapter.browse_percent != null) {
            classArr.push('ok');
          }
          if (chapter.id === this.model.last_chapter_id) {
            classArr.push('on');
            this.model.last_chapter = chapter;

            await this.chapterPlay(chapter);
          }
          chapter.class = classArr;
        }

        if (this.model.course_chapter_list.length === 0) {
          this.$message({
            type: 'warning',
            message: '课程无章节',
            onClose: () => {
              this.isExist = true;
              this.closeWindow();
            },
          });
        } else {
          // 学习时长计时器
          const learnTimer = () => {
            if (!this.isPause) {
              this.learnTime++;
              // 每3秒钟记录一次学习进度
              if (this.learnTime > 3 && this.learnTime % 3 === 0) {
                this.handlerCoursePlayTime();
              }
              // 每分钟记录一次学习进度
              if (this.learnTime % 60 === 0) {
                this.handlerCourseTrace();
              }
            }
            setTimeout(learnTimer, 1000);
          };
          const learnTimer2 = () => {
            if (this.$utils.matchType(this.iframeContentUrl) === 'video') {
              //拖动处理
              const cPlayer = this.$refs.cVideo.player;
              const currentt = cPlayer.currentTime();
              this.duration = cPlayer.duration();
              this.model.last_chapter.duration = this.duration;

              if (currentt > this.maxCurrentTime + 3) {
                //拖动快过5秒就不允许托动
                cPlayer.currentTime(this.currentTime);
              } else {
                if (currentt > this.maxCurrentTime) {
                  this.maxCurrentTime = currentt;
                }
                this.currentTime = currentt;
                this.model.last_chapter.currentTime = currentt;
                if (
                  !this.model.last_chapter.is_ok &&
                  this.duration > 0 &&
                  (currentt / this.duration) * 100 > 95
                ) {
                  this.model.last_chapter.is_ok = true;
                  this.handlerCourseTrace();
                }
              }
            }
            if (this.$utils.matchType(this.iframeMediaUrl) === 'video') {
              //拖动处理
              const mPlayer = this.$refs.mVideo.player;
              const currentt = mPlayer.currentTime();
              this.duration = mPlayer.duration();
              this.model.last_chapter.duration = this.duration;

              if (currentt > this.maxCurrentTime + 3) {
                //拖动快过3秒就不允许托动
                mPlayer.currentTime(this.currentTime); //更新播放器播放时间为原先的时间
              } else {
                if (currentt > this.maxCurrentTime) {
                  this.maxCurrentTime = currentt; //更新最大观看时间为当前播放时间
                }
                this.currentTime = currentt; //更新当前播放时间
                this.model.last_chapter.currentTime = currentt;
                if (
                  !this.model.last_chapter.is_ok &&
                  this.duration > 0 &&
                  (currentt / this.duration) * 100 > 95
                ) {
                  this.model.last_chapter.is_ok = true;
                  this.handlerCourseTrace();
                }
              }
            }
            setTimeout(learnTimer2, 1000);
          };
          setTimeout(learnTimer, 1000);
          setTimeout(learnTimer2, 1000);
          if (this.model.remind_clock) {
            // 防挂机提醒计时器
            const remindTimer = () => {
              this.isPause = !this.isPause;
              this.$confirm('请确认是否继续观看？', '提示', {
                type: 'info',
              })
                .then(() => {
                  this.isPause = !this.isPause;
                  setTimeout(remindTimer, this.model.remind_clock * 60 * 1000);
                })
                .catch(() => {
                  this.btnExitCourse();
                });
            };
            setTimeout(remindTimer, this.model.remind_clock * 60 * 1000);
          }
        }
      } else if (response.data.code === 404) {
        this.$message.error({
          message: '对不起，您查看的课程不存在！',
          onClose: () => {
            location.href = '/';
          },
        });
      } else {
        this.$message.error({
          message: '出错啦，请联系管理员！',
          onClose: () => {
            location.href = '/';
          },
        });
      }
    },
    async getMyCourseNotes() {
      const response = await this.$api.course.getMyCourseNotes(this.queryNote);
      this.noteList = response.data.data;
    },
    async postCourseNote(myNote) {
      const response = await this.$api.course.postCourseNote(myNote);
      if (response.data.code === 200) {
        this.noteContent = '';
        this.loadNoteData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 获取评价
    async getCourseEvaluation() {
      const response = await this.$api.course.getCourseEvaluation(
        this.queryEvaluation
      );
      this.evaluationList = response.data.data;
    },
    // 提交评价内容
    async postCourseEvaluation(myEvaluation) {
      const response = await this.$api.course.postCourseEvaluation(
        myEvaluation
      );
      if (response.data.code === 200) {
        this.isEvaluation = !this.isEvaluation;
        this.evaluationContent = '';
        this.loadEvaluationData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 获取评论
    async getCourseCDiscuss() {
      const response = await this.$api.course.getCourseDiscuss(
        this.queryCDiscuss
      );
      this.cdiscussList = response.data.data;
    },
    // 提交评论内容
    async postCourseCDiscuss(myCDiscuss) {
      const response = await this.$api.course.postCourseDiscuss(myCDiscuss);
      if (response.data.code === 200) {
        this.cDiscussContent = '';
        this.loadCDiscussData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    async clickChapter(item) {
      if (item.class.indexOf('on') === -1) {
        item.class.push('on');
        const chapter = this.model.last_chapter;
        chapter.class.splice(chapter.class.indexOf('on'), 1);
        if (chapter.class.indexOf('ok') === -1) {
          chapter.class.push('ok');
        }
        this.model.last_chapter = item;
        this.model.last_chapter_id = item.id;
        this.currentTime = item.act_time;
        this.duration = item.duration;

        await this.chapterPlay(item);
        this.handlerCourseTrace();
      }
    },
    async chapterPlay(item) {
      const cUrl = item.content_url;
      const mUrl = item.media_url;
      this.iframeContentUrl = !cUrl ? this.model.cover : cUrl;
      this.iframeMediaUrl = !mUrl ? this.model.cover : mUrl;
      if (this.$utils.matchType(this.iframeContentUrl) === 'video') {
        if (cUrl != null) {
          await this.getCoursePlayTime(cUrl);
          await this.getCoursePlayMaxTime(cUrl);
          // cOptions.maxCurrentTime=maxActTime;
        }
      }

      if (this.$utils.matchType(this.iframeMediaUrl) === 'video') {
        if (mUrl != null) {
          await this.getCoursePlayTime(mUrl);
          await this.getCoursePlayMaxTime(mUrl);
          // mOptions.maxCurrentTime=maxActTime;
        }
      }

      this.$nextTick(() => {
        if (this.$utils.matchType(this.iframeContentUrl) === 'video') {
          const cOptions = this.$refs.cVideo.options;
          const cPlayer = this.$refs.cVideo.player;
          this.$refs.cVideo.playFn = this.playFn;
          this.$refs.cVideo.pauseFn = this.pauseFn;
          this.$refs.cVideo.currentTime = this.currentTime;

          //cPlayer.currentTime(this.currentTime); //断点续学

          cOptions.poster = this.coursePoster;
          this.$set(cOptions.sources, 0, {
            type: 'video/mp4',
            src: cUrl,
            //src: "https://view.2amok.com/2019716/b3b8fb0d964323e7e018ac1a426272b6.mp4",
          });
        }
        if (this.$utils.matchType(this.iframeMediaUrl) === 'video') {
          const mOptions = this.$refs.mVideo.options;
          const mPlayer = this.$refs.mVideo.player;
          this.$refs.mVideo.playFn = this.playFn;
          this.$refs.mVideo.pauseFn = this.pauseFn;
          this.$refs.mVideo.currentTime = this.currentTime;

          //mPlayer.currentTime(this.currentTime); //断点续学
          mOptions.poster = this.coursePoster;

          this.$set(mOptions.sources, 0, {
            type: 'video/mp4',
            src: mUrl,
            //src: "https://view.2amok.com/2019716/b3b8fb0d964323e7e018ac1a426272b6.mp4",
          });
        }
        if (this.$utils.matchType(this.iframeContentUrl) === 'pdf') {
          this.iframePdfUrl = item.content_viewer_url;
        }
      });
    },
    playFn() {
      this.isPause = false;
    },
    pauseFn() {
      this.isPause = true;
      this.handlerCourseTrace();
    },
    handlerCourseTrace() {
      const chapter = this.model.last_chapter;
      const hasVideo =
        this.$utils.matchType(chapter.content_url) === 'video' ||
        this.$utils.matchType(chapter.media_url) === 'video';
      return this.$api.course.handlerCourseTrace({
        token: this.model.play_token,
        chapter_id: this.model.last_chapter_id,
        learn_time: this.learnTime,
        act_time: this.currentTime,
        duration: this.duration,
        has_video: hasVideo,
        is_required: this.$route.query.isRequired,
      });
    },
    handlerCoursePlayTime() {
      let url = this.iframeContentUrl;
      if (this.$utils.matchType(this.iframeContentUrl) === 'video') {
        url = this.iframeContentUrl;
      }
      if (this.$utils.matchType(this.iframeMediaUrl) === 'video') {
        url = this.iframeMediaUrl;
      }
      return this.$api.course.postSaveTime({
        src: url,
        time: this.currentTime,
      });
    },
    async getCoursePlayTime(url) {
      const response = await this.$api.course.getGetTime({
        src: url,
      });
      this.currentTime = response.data.data;
    },
    async getCoursePlayMaxTime(url) {
      const response = await this.$api.course.getGetMaxTime({
        src: url,
      });
      this.maxCurrentTime = response.data.data;
    },
    btnSubmitCourseNote(noteId) {
      // 笔记内容
      const noteContent = (
        noteId === 0
          ? this.noteContent
          : document.getElementById('note_txt_' + noteId).value
      ).trim();
      // 提交数据
      const submitData = {
        id: noteId,
        course_id: this.queryNote.courseId,
        content: noteContent,
      };
      if (noteContent.length === 0) {
        this.$message.warning('请输入笔记内容');
      } else {
        this.postCourseNote(submitData);
      }
    },
    // 提交评价
    btnSubmitCourseEvaluation() {
      // 提交数据
      const submitData = {
        course_id: this.query.id,
        score: this.myEvaluationScore,
        content: this.evaluationContent,
      };
      if (this.myEvaluationScore === 0) {
        this.$message.warning('请输入评价分数');
        return;
      }
      // console.log(submitData);
      this.postCourseEvaluation(submitData);
    },
    // 提交评价
    btnSubmitCourseCDiscuss() {
      // 提交数据
      const submitData = {
        course_id: this.query.id,
        content: this.cDiscussContent,
      };

      // console.log(submitData);
      this.postCourseCDiscuss(submitData);
    },
    btnExitCourse() {
      this.isExist = true;
      this.handlerCourseTrace()
        .then((response) => {
          this.closeWindow();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeWindow() {
      window.opener = null;
      window.open('about:blank', '_top').close();
    },
    btnshowFixedDiscuss() {
      this.showFixedDiscuss = !this.showFixedDiscuss;
      this.showFixedNote = false;
      this.showFixedCDiscuss = false;
    },
    btnshowFixedCDiscuss() {
      this.showFixedCDiscuss = !this.showFixedCDiscuss;
      this.showFixedNote = false;
      this.showFixedDiscuss = false;
    },
    btnshowFixedNote() {
      this.showFixedNote = !this.showFixedNote;
      this.showFixedDiscuss = false;
      this.showFixedCDiscuss = false;
    },
    btnShowSideList() {
      this.showSideList = !this.showSideList;
    },
  },
};
</script>
